import { ReactNode } from "react";
import { Tooltip } from "../../../../../components/Tooltip/Tooltip";
import { NO_HELPDESK_UPDATE_PERMISSION_MESSAGE } from "../utils/helpdeskPermissions";

interface PermissionDisabledWrapperProps {
  disabled: boolean;
  tooltip?: string;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

export const PermissionDisabledWrapper = ({
  disabled,
  tooltip = NO_HELPDESK_UPDATE_PERMISSION_MESSAGE,
  children,
  className = "",
  innerClassName = "",
  tooltipSide = "top",
}: PermissionDisabledWrapperProps) => {
  if (!disabled) return <>{children}</>;
  return (
    <Tooltip content={tooltip} side={tooltipSide}>
      <div className={`cursor-not-allowed ${className}`}>
        <div
          className={`pointer-events-none select-none ${innerClassName}`}
        >
          {children}
        </div>
      </div>
    </Tooltip>
  );
};
